import React from 'react';
import { FakeCell, Match } from '../../EventCell';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import { FlatButton } from 'material-ui';

export class EventsList extends React.Component {
    static defaultProps = {
        limit: 10,
    };

    state = { expanded: false };

    render = () => {
        const { expanded } = this.state;
        const { events = [], limit, title, eventId } = this.props;
        if (events.length === 0) return <div />;
        return (
            <div>
                {title && <p>{title}</p>}
                <div style={{ display: 'flex', flexWrap: 'wrap', margin: '15 0' }}>
                    {_.take(events, expanded ? events.length : limit).map(e => (
                        <Match
                            active={+eventId === +e.eventId}
                            style={{ width: 280 }}
                            onClick={ev =>
                                browserHistory.push(
                                    `/sm/browser/${e.sport}/tournaments/${e.tournamentTemplateId}/${
                                        e.tournamentId
                                    }/stages/${e.tournamentStageId}/rounds/${encodeURIComponent(
                                        e.properties.round,
                                    )}/events/${e.eventId}`,
                                )
                            }
                            key={e.eventId}
                            {...e}
                        />
                    ))}
                    {events.length > limit && !expanded && (
                        <FakeCell
                            text={`See all (${events.length})`}
                            onClick={e => this.setState({ expanded: true })}
                        />
                    )}
                </div>
            </div>
        );
    };
}

export default EventsList;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/pages/views/EventsList.js
 **/